module.exports = __webpack_public_path__ + "static/media/banner_420x230_3.ef2f3e3c.jpg";